export type RequestAuditDataFieldsBody = {
  categoryId: string;
  paramDefinitionId: string;
  value: string;
  updatedAt: string;
};
